






































































import {filterMatchColumns} from '@/helpers';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {combineLatest, of} from 'rxjs';
import {Component, Prop, Vue} from 'vue-property-decorator';
import BlankLoader from '@/components/common/BlankLoader.vue';
import CollapsibleTable from '@/components/common/CollapsibleTable.vue';
import DataFilter from '@/components/common/DataFilter.vue';
import ColorButton from '@/components/common/ColorButton.vue';
import DataTable from '@/components/common/DataTable.vue';
import {generateLangSubscriptions, observeFieldAsUIInput, observeProp} from '@/components/observe';
import {
  EditModes,
  TournamentActions,
  TournamentMutations,
  TournamentRequest, TournamentState,
} from '@/store/tournament/types';
import {ValidationObserver} from 'vee-validate';
import * as toastr from 'toastr';
import {mapActions, mapMutations, mapState} from 'vuex';

const namespace = 'tournament';

@Component<TournamentRequests>({
  components: {
    BlankLoader,
    CollapsibleTable,
    DataFilter,
    ColorButton,
    DataTable,
    ValidationObserver,
  },
  computed: mapState(namespace, {
    state: (state: TournamentState) => state,
  }),
  methods: {
    ...mapActions(namespace, [
      TournamentActions.StartLoading,
      TournamentActions.ApproveRequest,
      TournamentActions.RejectRequest,
    ]),
    ...mapMutations(namespace, [
      TournamentMutations.ToggleRequestEditMode,
      TournamentMutations.UpdateRequestOrganizerComment,
    ]),
  },
  subscriptions() {
    const lang$ = observeProp<string>(this, 'lang');
    return Object.assign(generateLangSubscriptions(lang$), {
      columns: combineLatest(
        of(this.allColumns),
        observeProp(this, 'state.requestEditModes'),
      ).pipe(map(([cols, modes]) => cols.filter((x: any) =>
        this.hasSomeEditMode(modes) && this.hasEditorRights || x.name !== 'actions'))),
      requests: combineLatest(
        observeProp(this, 'state.requests'),
        observeFieldAsUIInput(this, 'requestsFilter'),
      ).pipe(
        filter(([requests]: any) => !!requests),
        switchMap(([requests, requestsFilter]: any) => of(
          requests.filter((x: any) => this.filterMatch(x, requestsFilter)))),
      ),
      isRequestsLoaded: observeProp<boolean>(this, 'state.isLoaded'),
      editModes: observeProp<EditModes>(this, 'state.requestEditModes'),
      hasHttpError: observeProp<boolean>(this, 'state.hasHttpError').pipe(
        filter((x) => !!x),
        tap(() => this.showRequestError()),
      ),
    });
  },
})
export default class TournamentRequests extends Vue {
  public get hasEditorRights() {
    return this.canChangeRequests && this.isOrganizer;
  }

  public allColumns = [
    {name: 'name', title: 'name', width: '15%'},
    {name: 'date', title: 'date', width: '15%'},
    {name: 'playerComment', title: 'player_comment', width: '30%'},
    {name: 'organizerComment', title: 'organizer_comment', width: '30%'},
    {name: 'actions', title: 'actions', width: '10%'},
  ];
  public columnClasses = [
    {name: 'playerComment', class: 'tournament-request-player-comment'},
    {name: 'organizerComment', class: 'tournament-request-organizer-comment'},
  ];
  public requestsFilter = '';
  public commentValidator = 'max:128|required';

  @Prop() public isOrganizer!: boolean;
  @Prop() public forumThreadId!: number;
  @Prop() public canChangeRequests!: boolean;
  @Prop() public tournament!: number;
  @Prop() public lang!: string;

  public translate!: any;

  // vee-validate
  public errors!: any;

  // mapped state
  public state!: any;

  // mapped actions
  public startLoading!: any;
  public approveRequest!: any;
  public rejectRequest!: any;

  // mapped mutations
  public updateRequestOrganizerComment!: any;
  public toggleRequestEditMode!: any;

  public mounted() {
    this.startLoading({tournamentId: this.tournament, forumThreadId: this.forumThreadId});
  }

  public filterMatch(request: any, requestFilter: string) {
    return filterMatchColumns(request, requestFilter, [
      'username',
      'date',
      'organizerComment',
      'playerComment',
    ]);
  }

  public showRequestError() {
    toastr.error(this.translate.http_error, this.translate.error);
  }

  public canUpdateRequest(requestId: string) {
    const index = this.state.requests.findIndex((x: TournamentRequest) => x.id === requestId);
    return !this.errors.first(`organizerComment[${requestId}]`)
      && this.state.requests[index].organizerComment
      && this.state.requests[index].organizerComment.length;
  }

  public hasSomeEditMode(editModes: any) {
    return editModes && Object.keys(editModes).some((x) => !!editModes[x]);
  }
}
